/**
 * Generated from ch5_p13.fla
 */
export function ch5_p13(this: Ich5_p13) {
	const bg = this.bg;
	ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const tree = this.tree;
	ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_tree1.call(this.tree);
	tree.x = 0;
	tree.y = 384;
	tree.width = 942.00;
	tree.height = 768.00;
	tree.alpha = 1.00;
	if (tree.onLayout) tree.onLayout();
	const balloons = this.balloons;
	ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_balloons.call(this.balloons);
	balloons.x = 876.25;
	balloons.y = 384;
	balloons.width = 1248.50;
	balloons.height = 768.00;
	balloons.alpha = 1.00;
	if (balloons.onLayout) balloons.onLayout();
	const tyler = this.tyler;
	ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_tyler.call(this.tyler);
	tyler.x = 1024.25;
	tyler.y = 384;
	tyler.width = 820.50;
	tyler.height = 768.00;
	tyler.alpha = 1.00;
	if (tyler.onLayout) tyler.onLayout();
	const frameRight = this.frameRight;
	ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeRline.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 440.5;
	linesRight.width = 81.50;
	linesRight.height = 333.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeLlines.call(this.linesLeft);
	linesLeft.x = 9.5;
	linesLeft.y = 384;
	linesLeft.width = 99.00;
	linesLeft.height = 768.00;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_bg(this: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p13_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_tree1(this: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_tree1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p13_tree1", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_balloons(this: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_balloons) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p13_balloons", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_tyler(this: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch5_p13_tyler", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeRframe(this: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeRline(this: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeRline) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rline", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeLframe(this: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeLlines(this: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeLlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("Llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich5_p13Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich5_p13Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich5_p13Sprite extends Ich5_p13Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich5_p13Text extends Ich5_p13Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich5_p13Polygon extends Array<number> {
}
interface Ich5_p13 {
	readonly bg: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_bg;
	readonly tree: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_tree1;
	readonly balloons: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_balloons;
	readonly tyler: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_tyler;
	readonly frameRight: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeRframe;
	readonly linesRight: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeRline;
	readonly frameLeft: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeLframe;
	readonly linesLeft: Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeLlines;
}
interface Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_bg extends Ich5_p13Sprite {
}
interface Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_tree1 extends Ich5_p13Sprite {
}
interface Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_balloons extends Ich5_p13Sprite {
}
interface Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_tyler extends Ich5_p13Sprite {
}
interface Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeRframe extends Ich5_p13Sprite {
}
interface Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeRline extends Ich5_p13Sprite {
}
interface Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeLframe extends Ich5_p13Sprite {
}
interface Ich5_p13_hh_ch5_72dpi_p013psdAssetch5_p13_wcframeLlines extends Ich5_p13Sprite {
}
